module.exports = __webpack_public_path__ + "img/02-OTHER.945d1560.png";